<template>
  <el-dialog
   
    title="截图"
    :visible.sync="DialogVisible"
    append-to-body
    width="800px"
    center
    :before-close="handleClose"
  >
    <div class="home">
      <div class="cropper" >
        <vueCropper
          ref="cropper"
          :img="option.img"
          :zoomOnWheel="option.zoomOnWheel"
          :outputSize="option.outputSize"
          :outputType="option.outputType"
          :canScale="option.canScale"
          :autoCrop="option.autoCrop"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :canMoveBox="option.canMoveBox"
          :canMove="option.canMove"
          :centerBox="option.centerBox"
          :info="option.info"
          :fixedBox="option.fixedBox"
          @realTime="realTime"
        ></vueCropper>
      </div>
      <!-- <img :src="previewImg" alt="" class="previewImg" ref="img" /> -->

      <!-- <img :src="resImg" alt="" v-if="resImg" class='previewImg'> -->
    </div>
    <div class="btn">
      <el-button type="primary" @click="handleClick(2)">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { VueCropper } from 'vue-cropper'
export default {
  props: {
    pic: null,
    courseFile: null,
  },
  data() {
    return {
      DialogVisible: false,
      option: {
        img: '', // 裁剪图片地址
        outputSize: 1, // 裁剪生成图片质量
        outputType: 'jpeg', // 裁剪生成图片格式
        canScale: true, // 图片是否允许滚轮播放
        autoCrop: true, // 是否默认生成截图框 false
        info: true, // 是否展示截图框信息
        autoCropWidth: 640, // 生成截图框的宽度
        autoCropHeight: 360, // 生成截图框的高度
        canMoveBox: true, // 截图框是否可以拖动
        fixedBox: true, // 固定截图框的大小
        canMove: false, // 上传图片是否可拖动
        centerBox: false, // 截图框限制在图片里面
        zoomOnWheel:false
      },
      resImg: null, //截图后图片
      previewImg: null, // 预览后的图片
      previewObj: {
        width: 640,
        height: 360,
      },
      index:null,
      imgObj: {
        width: 640,
        height: 360,
      },
    }
  },
  components: {
    VueCropper,
  },
  watch: {
    'option.img': {
      handler: function (val) {
        const that = this
        const img = new Image()
        img.src = val
        img.onload = function () {
          that.imgObj.width = this.width
          that.imgObj.height = this.height
        }
      },
      immediate: true,
    
    },
  },
  created() {
    // console.log(this.pic)
    if (this.pic) {
      this.filetoBase64(this.pic)
    }
    this.DialogVisible = true
  },
  methods: {
    filetoBase64(file) {
      let reader = new FileReader() //实例化文件读取对象
      reader.readAsDataURL(file) //将文件读取为 DataURL,也就是base64编码
      reader.onload = (e) => {
        //文件读取成功完成时触发
        let dataURL = e.target.result //获得文件读取成功后的DataURL,也就是base64编码
        this.option.img = dataURL
      }
    },
    base64toFile(data, fileName) {
      const dataArr = data.split(',')
      const byteString = atob(dataArr[1])
      const options = {
        type: 'image/png',
        endings: 'native',
      }
      const u8Arr = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i++) {
        u8Arr[i] = byteString.charCodeAt(i)
      }
      return new File([u8Arr], fileName + '.jpg', options) //返回文件流
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('file', this.base64toFile(file, 11))
      this.$request
        .post('/course/uploadPic', formData, {
          Headers: {
            'Content-Type': 'multipart/form-data;',
          },
        })
        .then((res) => {
          this.$emit('changeRul',{file:this.base64toFile(file, 11),url:res},this.index)
          // 取消阻止
          this.$refs.cropper.cancelScale()
        })
        
    },
    handleClick(val) {
      //获取base64文件
      this.$refs.cropper.getCropData((data) => {
        this.uploadFile(data)
      })
    },
    handleDownload(url) {
      var a = document.createElement('a') // 生成一个a元素
      var event = new MouseEvent('click') // 创建一个单击事件
      a.download = 'photo' // 设置图片名称, 这里可以自定义，也可以获取图片名称进行修改
      a.href = url // 将生成的URL设置为a.href属性
      a.dispatchEvent(event) // 触发a的单击事件
    },
    realTime(data) {
      if (this.option.img) {
        const that = this
        this.$refs.cropper.getCropBlob((data) => {
          // 这里data数据为Blob类型，blobToDataURI方法转换成base64
          // console.log(data)
          this.blobToDataURI(data, function (res) {
            // console.log(res)
            that.previewImg = res
          })
        })
      }
    },
    blobToDataURI(blob, callback) {
      var reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onload = function (e) {
        callback(e.target.result)
      }
    },
    destroyed() {
     
    },
    handleClose(){
         this.$emit('changeRul',{file:'',url:''},this.index)
          // 取消阻止
      this.$refs.cropper.cancelScale()
      console.log("===========================")
    }
  },
  mounted() {}
}
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #eee;
  display: flex;
  justify-content: space-around;
}
.btn {
  display: flex;
  justify-content: space-around;
  margin: 20px;
}
.cropper {
  width: 800px;
  height: 370px;
  border: 1px solid orange;
}
.previewImg {
  width: 350px;
  height: 370px;
  object-fit: cover;
}
.vue-cropper{
background-image: none !important;
background-color: white;
}
</style>